<template>
  <button
    class="reseller-button"
    :class="[
      type ? 'reseller-button--' + type : '',
      buttonSize ? 'reseller-button--' + buttonSize : ''
    ]"
    @click="$_handleClick"
    :type="nativeType"
  >
    <span v-if="$slots.default"><slot></slot></span>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    nativeType: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    buttonSize() {
      return this.size;
    }
  },

  methods: {
    $_handleClick(evt) {
      this.$emit('click', evt);
    }
  }
};
</script>

<style></style>
